import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ServerService } from '../../../service/server/server.service';
import { Params, ActivatedRoute } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ReceptionDetaileComponent } from "../reception-detaile/reception-detaile.component";
import { WharehouseExit2Component } from '../../../wharehouse-reception/wharehouse-exit2/wharehouse-exit2.component';
import { HttpClient } from '@angular/common/http';
import { RepairmanShelfLogComponent } from '../../repairman-shelf-log/repairman-shelf-log.component';
import { UserVideoComponent } from '../../../user/user-video/user-video.component';
import { RepairmanDeliveryComponent } from '../../repairman-delivery/repairman-delivery.component';
import { MessageService } from '../../../service/message/message.service';
import { RecieveDetaileComponent } from "../../../finance/finance-recieve/recieve-detaile/recieve-detaile.component";
import { ChartsComponent } from '../../..//finance/charts/charts/charts.component';
import { TableColumn } from '../../..//models/TableColumn';
import { ColumnConfigDialogComponent } from '../../..//models/ColumnConfigDialog/ColumnConfigDialog.component';
import { ConfirmDialogComponent } from '../../..//models/ConfirmDialog/ConfirmDialog.component';
import { ReceptionSmsComponent } from '../reception-sms/reception-sms.component';
import { ReceptionNewSmsComponent } from '../reception-new-sms/reception-new-sms.component';
import { ReceptionRepairmanSmsComponent } from '../reception-repairman-sms/reception-repairman-sms.component';
import { ReceptionTimelineSmsComponent } from '../reception-timeline-sms/reception-timeline-sms.component';
import { ReceptionPaymentComponent } from '../reception-payment/reception-payment.component';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-reception-list',
  templateUrl: './reception-list.component.html',
  styleUrls: ['./reception-list.component.scss']
})
export class ReceptionListComponent implements OnInit, OnDestroy {
  //**********************************************************
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public token: any = Math.floor(Math.random() * 99999999999999);
  public loading: boolean = false;
  public loading2: boolean = false;
  public show_excel: boolean = false;
  public loading1: boolean = false;
  public seeOwnPanel: boolean = false;
  public status_show_id: boolean = false;
  public show_cellphone: boolean = true;
  public indeterminate: boolean = false;
  public checked: boolean = false;
  public see_own_panel: number = 0;
  public sendsms: number = -1;
  public count_total: number = 1;
  public page: number = 1;
  public excel: number = 1;
  public list_services: any = [];
  public list_cellphone: any = [];
  public list_record: any = [];
  public list_status: any = [];
  public search_array: any = [];
  public selected_record: any = [];
  public subscription: Subscription | any;
  public server!: string;
  public server_main!: string;
  public site!: string;
  public user_id!: number;
  public user_token!: string;
  public user_store!: string;
  public task_type!: number;
  public asc_desc: string = 'asc';
  public order!: string;
  public i!: number;
  public confirm_delete!: boolean;
  public page_number_first!: number;
  public page_number_second!: number;
  public code!: any;
  public code_movie!: any;
  public export_code!: string;
  public type_task!: number;
  public type!: number;
  public type_search!: number;
  public search_all!: string;
  public delivery!: number;
  public x!: any;
  public ready_delivery!: number;
  public ready_reparing!: number;
  public payment_dialog!: boolean;
  public material_dialog!: boolean;
  public back_i!: number;
  public level!: number;
  public creator!: number;
  public video!: string;
  public default!: number;
  public access_service!: number;
  public path_export!: string;
  public query_customer!: number;
  public query_repairman!: number;
  public id!: number;
  public pre_status!: boolean;
  public next_status!: boolean;
  public new_status!: boolean;
  public title!: string;
  public select_all!: boolean;
  public mat_table_selectedRow!: any;
  public mat_table_hoverRow!: any;
  public dataSource!: any;
  public displayedColumns = ['row', 'user', 'invoice', 'cellphone', 'id2', 'id', 'shelf', 'device', 'brand', 'model', 'searial', 'date', 'time', 'date2', 'time2', 'estimated_time', 'status', 'device_status', 'operation'];
  public rstatus!: any;
  public rstatus_default!: any;
  public repairman!: number;
  public pos!: string;
  public columns: TableColumn[] = this.displayedColumns.map(column => new TableColumn(column, false, true, true));
  public orginal_order: string = "orginal_reception_list_columns";
  public title_of_order: string = "reception_list_columns";
  //************** */
  constructor(
    public serverService: ServerService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public matSnackBar: MatSnackBar,
    public dialog: MatDialog,
    public http: HttpClient,
    public title1: Title,
    public messageService: MessageService
  ) {
    this.server = this.serverService.get_server();
    this.server_main = this.serverService.get_server_main();
    this.site = this.serverService.get_site();


  }
  ngOnInit() {

    this.setcolConfig();

    localStorage.setItem(this.orginal_order, JSON.stringify(this.displayedColumns));

    this.serverService.status1(2);
    if (this.user_info) {
      this.user_store = this.user_info.user_store;
      this.user_id = this.user_info.user_id;
      this.user_token = this.user_info.user_token;
    }
    this.activatedRoute.params.subscribe(
      (params: Params) => {

        this.code = params['id'];

        this.title1.setTitle("");

        if (this.code == 197) {
          this.title1.setTitle("لیست پذیرش ها");
        }

        this.id = params['id'];

        this.repairman = params['repairman'];
        if (!this.page) this.page = 1;
        this.search_array = [];
        this.get_movie();

      }
    )
    this.activatedRoute.queryParams.subscribe(
      (params) => {
        this.page = Number(params['page']);
        this.search_all = params['all'];
        this.query_customer = params['customer'];
        this.rstatus = params['rstatus'];
        this.pos = params['pos'];
        if (params['back_i']) this.back_i = params['back_i'];
        this.query_repairman = params['repairman'];
        if (params['new'] == 1) {
          this.open_detaile(0, 1, 0);
        }
        this.check_access(4, 1, 0, 1, 1);
      }
    );
    //**************
  }//end ngOnInit
  //****************************************************************************
  check_access(type_task: any, page: number, id: any, excel: number, loading: number): any {
    var code = this.code;
    if (this.code == 170) { code = 197; }
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    //else { this.matSnackBar.dismiss(); }
    if (loading == 1) this.loading = true;
    this.subscription = this.serverService.post_address_token(this.server, 'new_address', { 'address': 6, type: 'user', user_id: this.user_id, id: code }, this.user_token).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          this.creator = res['creator'];
          this.level = res['level'];
          this.access_service = res['result'][0].count;
          this.path_export = res['path_export'];
          this.show_cellphone = res['show_cellphone'];
          this.check_access2(type_task, page, id, excel, loading, res['result'][0].count);
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());
        }
      }
    )
  }
  check_access2(type_task: any, page: number, id: any, excel: number, loading: number, access_service: number): any {
    var code = this.code;
    if (this.code == 170) { code = 197; }
    this.subscription = this.serverService.post_address_token(this.server_main, 'new_address', { 'address': 6, user_id: this.creator, id: code }, this.user_token).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
            return false;
          }
          else if (this.level == 3 && access_service == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
            return false;
          }
          this.title = res['result'][0].title;
          this.video = res['result'][0].video;
          this.loading = false;
          if (type_task == 3) {
            this.delete(id);
          }
          if (type_task == 4) {
            this.get_reception_with_full_shelf();
            if (this.level == 3) this.check_user_access_only_his_panel_config(page);
            else this.load_data(page, 1, loading, -1);
          }
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());
        }
      }
    )
  }
  check_user_access_only_his_panel_config(page: number): any {
    var obj = {
      address: 6816,
      id: this.user_id,
      creator: this.creator
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1 && res['num'] == 1) {
          this.seeOwnPanel = res['result'][0].user_can_only_see_his_own_list;
          this.load_data(page, 1, 1, -1);
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  sort(sort: string, asc_desc: string) {
    if (asc_desc == 'asc') this.asc_desc = 'desc';
    else this.asc_desc = 'asc';
    this.order = sort + " " + this.asc_desc;
    this.load_data(1, 1, 1, -1);
  }
  reset_sort(sort: string, asc_desc: string) {
    this.order = sort + " " + asc_desc;
    this.load_data(1, 1, 1, -1);
  }
  load_data(page: number, excel: number, loading: number, changedRows: number) {
    const savedColumnConfig = localStorage.getItem(this.title_of_order);
    if (savedColumnConfig) {
      const savedColumns = JSON.parse(savedColumnConfig);
      this.columns = savedColumns.map((col: { name: string; isHiden: boolean | undefined; sortable: boolean | undefined; hideable: boolean | undefined }) => new TableColumn(col.name, col.isHiden, col.sortable, col.hideable));
      this.displayedColumns = this.columns.filter(cd => !cd.isHiden).map(cd => cd.name);
    }
    if (loading == 1) this.loading = true;
    if (page == 1) { this.page = 1; }
    if (page == 2) { this.page = this.page + 1; }
    if (page == 4) { this.page = Math.ceil(this.count_total / 20); }
    if (page == 3) { this.page = this.page - 1; }
    if (page == 5) { this.page = 1; }
    var obj = {
      'address': 6845,
      "page": this.page,
      'type': this.type,
      'level': this.level,
      'excel': excel,
      'user_id': this.user_id,
      'search': this.search_array,
      'search_all': this.search_all,
      'changedRows': changedRows,
      'rstatus': this.rstatus,
      'repairman': this.repairman,
      'pos': this.pos,
      'id': this.id,
      'creator': this.creator,
      'path_export': this.path_export,
      'show_cellphone': this.show_cellphone,
      'query_customer': this.query_customer,
      'seeOwnPanel': this.seeOwnPanel,
      'query_repairman': this.query_repairman,
      'order': this.order,
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (excel == 1) {
            if (changedRows == -1) this.list_record = [];
            if (changedRows > 0 || changedRows == -1) {
              var x: any;
              for (var i = 0; i < res['num']; i++) {
                res['result'][i].sum = Number(res['result'][i].sum_order) - Number(res['result'][i].sum_payment);
                x = new Date(res['result'][i].repairman_reception_estimated_time).getTime() - new Date(res['date2']).getTime();
                res['result'][i].urgent = Math.round(x / (1000 * 3600 * 24))
                this.list_record.push(res['result'][i]);
              }//end for
            }
            this.delivery;
            this.default = res['default1'];
            this.payment_dialog = res['payment_dialog'];
            this.material_dialog = res['material_dialog'];
            this.delivery = res['delivery'];
            this.ready_delivery = res['ready_delivery'];
            this.ready_reparing = res['ready_reparing'];
            this.dataSource = new MatTableDataSource(this.list_record);
            this.count_total = res['count'];
            this.pages(0);
            this.serverService.change_window_resize(2, '', 0);
            this.serverService.send_services_id(this.code);
            this.serverService.send_reception_rstatus({ rstatus_id: this.rstatus, code: this.code, level: this.level, type: 'load' });
          }
          else if (excel == 2) {
            this.export_excel(res['export_code']);
          }
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }//end else
      }//end res:Response
    ) //ens dubscribe
  }//end load data
  pages(count: number) {
    this.count_total = this.count_total + count;
    this.page_number_first = this.page * 20 - 19;
    this.page_number_second = this.page * 20;
    if (this.page_number_first == 1) { this.pre_status = true; this.new_status = false; }
    else { this.pre_status = false; this.new_status = true; }
    if (this.list_record.length < 20 || (this.page * 20 >= this.count_total)) {
      this.page_number_second = this.count_total;
      this.next_status = true;
    }//end if
    else { this.next_status = false; }
  }
  export_excel(code: number) {
    if (code > 0) {
      var x = <any>document.getElementById("excel");
      x.href = this.site + "/export/" + code + ".xlsx";
      x.click();
    }
  }
  //*************************************************************************************** */
  open_video() {
    this.dialog.open(UserVideoComponent, {
      width: '45rem',
      height: 'auto',
      data: { id: this.code_movie }
    })
  }
  get_movie(): any {
    this.code_movie = this.code;
    var user_id = this.user_id;
    if (this.code == 170) { this.code_movie = 166; user_id = 2445; }
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, user_id: user_id, id: this.code_movie }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.video = res['result'][0].video;
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());
        }
      }
    )
  }
  open_log(reception: any) {
    this.dialog.open(RepairmanShelfLogComponent, {
      width: '67rem',
      height: 'auto',
      data: { reception: reception }
    })
  }
  get_menu(i: number, x: any) {
    this.x = x;
    this.i = i;
  }
  show_id() {
    this.status_show_id = !this.status_show_id;
  }
  //************************************************************************************************************ */
  show_factor1() {
    window.open(this.serverService.get_my_domain() + "/tracking/" + this.x.repairman_reception_id + "/" + this.x.repairman_reception_code, "_blank");
  }
  show_factor2() {
    window.open(this.serverService.get_my_domain() + "/tracking2/" + this.x.repairman_reception_id + "/" + this.x.repairman_reception_code + "?type=reception", "_blank");
  }
  show_factor3() {
    window.open("https://my.finty.ir/print-label-address/" + this.x.repairman_reception_id + "/" + this.x.repairman_reception_code, "_blank");
  }
  show_factor4() {
    window.open(this.serverService.get_my_domain() + "/rtl/" + this.x.repairman_reception_id + "/" + this.x.repairman_reception_code, "_blank");
  }
  show_invoice_of_person() {
    this.loading2 = true;
    var obj = {
      'address': 7236,
      'creator': this.creator,
      'id': this.x.repairman_reception_id,
      'user': this.x.customer_id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          window.open("/home/financial2/202?user=" + this.x.customer_id, "_blank");
          this.loading2 = false;
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  show_invoice_of_cardex() {
    window.open("/home/finance-cardex/226?user=" + this.x.customer_id, "_blank");
  }
  barcode() {
    window.open(this.site + "/barcode/barcode.html?type=1&creator=" + this.creator + "&userId=" + this.user_id + "&id=" + this.x.repairman_reception_id2 + "&token=" + this.x.repairman_reception_code + "&bottomtext=" + this.x.repairman_shelf_title + "&toptext=" + this.x.user_title, "_blank");
  }
  //************************************************************************************************************ */
  open_delivery(i: number, id: number) {
    const dialogRef = this.dialog.open(RepairmanDeliveryComponent, {
      width: '25rem',
      height: 'auto',
      data: { id: id, creator: this.creator }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          this.list_record.splice(i, 1);
          this.dataSource.data = this.list_record;
        }
      }
    )
  }
  get_code_delivery(id: number): any {
    return Math.floor(id * id / 2)
  }
  //************************************************************************************************************ */
  open(i: number, type_task: number, id: number, id2: number) {
    if (this.payment_dialog == true) {
      this.open_payment(i, id, id2);
    }
    else if (this.material_dialog == true) {
      this.open_exit(i, id);
    }
    else {
      this.open_detaile(i, type_task, id);
    }
  }
  open_detaile(i: number, type_task: number, id: number): any {
    this.back_i = -1;
    var width = '75rem';
    if (type_task == 3) {
      width = '40rem';
    }
    const dialogRef = this.dialog.open(ReceptionDetaileComponent, {
      width: width,
      height: 'auto',
      disableClose: true,
      data: {
        'type_task': type_task,
        'id': id, 'i': i,

        'search_array': this.search_array,
        'code': 160,
        'title': this.title,
        'creator': this.creator,
        'default_rstatus': this.default,
        'rstatus': this.rstatus
      }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          var change_status = 0;
          if (type_task == 1) {
            this.pages(1);
            this.list_record.push(res.result);
            var index;
            index = this.list_record.length - 1;
            this.dataSource.data = this.list_record;
            if (res.isprint == 1) window.open(this.serverService.get_my_domain() + "/tracking/" + res.result.repairman_reception_id + "/" + res.result.repairman_reception_code, "_blank");
            if (res.deposite == 1) this.open_new_recieve(index);
            if (res.result.confirm_sms == true) {
              this.send_sms_after_save_new_reception(index);
              var message = "پذیرش با موفقیت ذخیره شد . و پیامک برای مشتری ارسال شد";
              this.message(true, this.messageService.message(message), 1, this.messageService.close());
            } else {
              var message = "پذیرش با موفقیت ذخیره شد . اما پیامک برای مشتری ارسال نشد";
              this.message(true, this.messageService.message(message), 1, this.messageService.close());
            }
            this.serverService.send_reception_rstatus({ rstatus_id: this.rstatus, code: this.code, level: this.level, alter: true });
          }
          else if (type_task == 2) {
            this.list_record[i].repairman_shelf_title = res.result.repairman_shelf_title;
            this.list_record[i].user_title = res.result.user_title;
            this.list_record[i].user_cellPhone = res.result.user_cellPhone;
            this.list_record[i].wharehouse_device_title = res.result.wharehouse_device_title;
            this.list_record[i].repairman_reception_urgent = res.result.repairman_reception_urgent;
            this.list_record[i].repairman_brand_title = res.result.repairman_brand_title;
            this.list_record[i].repairman_model_title = res.result.repairman_model_title;
            this.list_record[i].repairman_reception_searial = res.result.repairman_reception_searial;
            this.list_record[i].repairman_reception_date = res.result.repairman_reception_date;
            this.list_record[i].repairman_rstatus_title = res.result.repairman_rstatus_title;
            this.list_record[i].repairman_device_status_title = res.result.repairman_device_status_title;
            this.list_record[i].repairman_title = res.result.repairman_title;
            this.list_record[i].repairman_reception_color = res.result.repairman_reception_color;
            this.list_record[i].repairman_reception_approximate = res.result.repairman_reception_approximate;
            this.list_record[i].repairman_reception_editor_date = res.result.repairman_reception_editor_date;
            this.list_record[i].repairman_reception_editor_time = res.result.repairman_reception_editor_time;
            this.list_record[i].repairman_reception_comment3 = res.result.repairman_reception_comment3;
            this.list_record[i].repairman_reception_estimated_time = res.result.repairman_reception_estimated_time;
            this.list_record[i].user_sex_title = res.result.user_sex_title;
            if (res.result.confirm_sms == true) {
              this.send_sms_after_update_reception(i, id);
            }
            this.serverService.send_reception_rstatus({ rstatus_id: this.rstatus, code: this.code, level: this.level, alter: true });
            if (res.isprint == 1) window.open(this.serverService.get_my_domain() + "/tracking/" + id + "/" + res.result.repairman_reception_code, "_blank");
            if (res.deposite == 1) this.open_new_recieve(i);
            if (this.pos == 'right') {
              if (this.rstatus != res.result.repairman_reception_status) {
                this.list_record.splice(i, 1);
                this.dataSource.data = this.list_record;
                this.pages(-1);
                change_status = 1;
              }
            } else {
              if (this.default == 1) {
                if (res.result.repairman_rstatus_default == 0) {
                  this.list_record.splice(i, 1);
                  this.dataSource.data = this.list_record;
                  this.pages(-1);
                  change_status = 1;
                }
              }
              if (this.delivery == 1) {
                if (res.result.repairman_rstatus_empty_shelf == 0) {
                  this.list_record.splice(i, 1);
                  this.dataSource.data = this.list_record;
                  this.pages(-1);
                  change_status = 1;
                }
              }
              if (this.ready_delivery == 1) {
                if (res.result.repairman_rstatus_sub_ready_delivery == 0) {
                  this.list_record.splice(i, 1);
                  this.dataSource.data = this.list_record;
                  this.pages(-1);
                  change_status = 1;
                }
              }
              if (this.ready_reparing == 1) {
                if (res.result.repairman_rstatus_repairing == 0) {
                  this.list_record.splice(i, 1);
                  this.dataSource.data = this.list_record;
                  this.pages(-1);
                  change_status = 1;
                }
              }
            }
          }
          else if (type_task == 3) {
            var excel = res.export_excel;
            this.search_array = [];
            this.search_array = res;
            this.check_access(4, 1, 0, excel, 1);
          }
        }
      }
    )
  }
  open_Menu(id: number): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading1 = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6122, id: id }).subscribe(
      (res: any) => {
        this.list_services = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            res['result'][i].logo = res['result'][i].user_logo_site + "/" + res['result'][i].user_logo;
            this.list_services.push(res['result'][i]);
          }//end for
          this.loading1 = false;
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.loading1 = false;
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  get_bg(id: number) {
    this.id = id;
  }
  //*******************************************************************************
  delete(id: number): any {
    var i = this.list_record.findIndex((index: any) => index.repairman_reception_id == id);
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    var confirm_delete;
    confirm_delete = window.confirm(this.messageService.message_delete_accept());
    this.loading = false;
    if (confirm_delete == true) {
      this.loading = true;
      var obj = {
        'address': 7235,
        "user_id": this.user_id,
        'creator': this.creator,
        'id': id,
        'last_financial2_id': this.list_record[i].repairman_reception_last_financial2_id
      }
      this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
        (res: any) => {
          if (res['status'] == 1) {
            this.list_record.splice(i, 1);
            this.load_data(this.page, 1, 1, res['result'].changedRows);
            this.dataSource.data = this.list_record;
            this.serverService.send_reception_rstatus({ rstatus_id: this.rstatus, code: this.code, level: this.level, alter: true });
            this.message(true, this.messageService.delete(), 1, this.messageService.close());
          }//end if
          else if (res['status'] == 4) {
            var pe_message = ".این رکورد یا پرداختی دارد یا قطعات و خدمات برای آن درج شده است . قادر به حذف نیستید";
            this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
          }
          else {
            this.message(true, this.messageService.message_error(), 1, this.serverService.message_action());
          }//end else
        }//end res:Response
      )//end this.subscription
    }//end this.confirm_delete == true
  }//end delete
  open_payment(i: number, id: number, id2: number) {
    const dialogRef = this.dialog.open(ReceptionPaymentComponent, {
      width: '50rem',
      height: 'auto',
      data: {
        'code': this.code,
        'id': id,
        'creator': this.creator,
        'id2': id2,
        'level': this.level
      }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          this.list_record.splice(i, 1);
          this.dataSource.data = this.list_record;
          this.pages(-1);
          if (res.result.confirm_sms == true) {
            this.check_charge_sms(i, id);
          }
          this.serverService.send_reception_rstatus({ rstatus_id: this.rstatus, code: this.code, level: this.level, alter: true });
        }//end if
      }
    )
  }
  open_exit(i: number, id: number) {
    this.back_i = -1;
    const dialogRef = this.dialog.open(WharehouseExit2Component, {
      'width': '85rem',
      'height': 'auto',
      data: {
        'reception_id': id,
        'token': this.token,
        'ref': 'exit',
        'type': 2,
        'code': 160,
        'creator': this.creator,
        'level': this.level,
        'default_rstatus': this.default
      }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        var change_status = 0;
        if (res) {

          this.list_record[i].repairman_rstatus_title = res.result.repairman_rstatus_title;
          this.list_record[i].repairman_reception_invoice_count = res.result.repairman_reception_invoice_count;
          if (res.isprint == 1) window.open(this.serverService.get_my_domain() + "/tracking2/" + id + "/" + res.result.repairman_reception_code, "_blank");
          if (this.pos == 'right') {
            if (this.rstatus != res.result.repairman_reception_status) {
              this.list_record.splice(i, 1);
              this.dataSource.data = this.list_record;
              this.pages(-1);
              change_status = 1;
            }
          }
          else {
            if (this.default == 1) {
              if (res.result.repairman_rstatus_default == 0) {
                this.list_record.splice(i, 1);
                this.dataSource.data = this.list_record;
                this.pages(-1);
                change_status = 1;
              }
            }
            if (this.delivery == 1) {
              if (res.result.repairman_rstatus_empty_shelf == 0) {
                this.list_record.splice(i, 1);
                this.dataSource.data = this.list_record;
                this.pages(-1);
                change_status = 1;
              }
            }
            if (this.ready_delivery == 1) {
              if (res.result.repairman_rstatus_sub_ready_delivery == 0) {
                this.list_record.splice(i, 1);
                this.dataSource.data = this.list_record;
                this.pages(-1);
                change_status = 1;
              }
            }
            if (this.ready_reparing == 1) {
              if (res.result.repairman_rstatus_repairing == 0) {
                this.list_record.splice(i, 1);
                this.dataSource.data = this.list_record;
                this.pages(-1);
                change_status = 1;
              }
            }
          }
          this.serverService.send_reception_rstatus({ rstatus_id: this.rstatus, code: this.code, level: this.level, alter: true });
        }
        if (res.result.confirm_sms == true) {
          this.check_charge_sms(i, id);
        }
      }
    )
  }
  //************************************************************************قسمت پایین برای موضوع دریافت مالی مثل بیعانه می باشد*********************************************************** */
  open_new_recieve(reception_i: number): any {
    var obj = {
      address: 6996,
      user_id: this.user_id,
      creator: this.creator
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.open_detaile_recieve(reception_i, -1, 2, res['id']);
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());

        }
      }
    )
  }
  open_detaile_recieve(reception_i: number, i: number, type_task: number, id: number) {
    this.dialog.open(RecieveDetaileComponent, {
      width: '75rem',
      height: 'auto',
      disableClose: true,
      data: {
        'type_task': type_task,
        'id': id,
        'i': i,
        'code': 160,
        'creator': this.creator,
        'ref': 'reception_deposite',
        'reception_number': this.list_record[reception_i].repairman_reception_id2,
        'user': this.list_record[reception_i].customer_id,
        'user_title': this.list_record[reception_i].user_title,
      }
    });
  }
  //***************************************************************چک کردن مقدار شارژ پیامک********************************************* */
  check_charge_sms(i: number, id: number): any {
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', { address: 6312, creator: this.creator }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            if (res['result'][0].amount >= 2000) {
              this.send_sms_after_update_reception(i, id);
            }
            else {
              var pe_message = "رکورد یا موفقیت ذخیره شد ولی قادر به ارسال پیامک نمی باشید لطفا شارژ نمائید";
              this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
            }
          }
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  //***************************************************برای ارسال پیامک بعد از تغییر وضعیت در پاپ آپ پذیرش******************************** */
  open_sms_for_update_reception(i: number) {
    this.dialog.open(ReceptionSmsComponent, {
      'width': '30rem',
      'height': 'auto',
      data: { reception_id: this.list_record[i].repairman_reception_id, creator: this.creator }
    })
  }
  send_sms_after_update_reception(i: number, id: number): any {
    var token = this.serverService.get_my_domain() + "/recipt-printer-invoice2/" + id;
    var obj = {
      'address': 7270,
      'user_id': this.user_id,
      'creator': this.creator,
      'token': token,
      'id': id,
    }
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', obj).subscribe(
      (res: any) => {
        this.serverService.send_sms_charge();
        var pe_message = "پیامک با موفقیت ارسال شد";
        this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
      })
  }
  //***************************************************برای ارسال پیامک پذیرش جدید به مشتری جدید******************************* */
  open_again_sms_for_new_reception(i: number) {
    this.dialog.open(ReceptionNewSmsComponent, {
      'width': '30rem',
      'height': 'auto',
      data: { reception_id: this.list_record[i].repairman_reception_id, creator: this.creator }
    })
  }
  send_sms_after_save_new_reception(i: number): any {
    var token = this.serverService.get_my_domain() + "/tracking/" + this.list_record[i].repairman_reception_id;
    var obj = {
      'address': 7233,
      'reception_id': this.list_record[i].repairman_reception_id,
      'token': token,
      'creator': this.creator
    }
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', obj).subscribe(
      (res: any) => {
        this.serverService.send_sms_charge();
      })
  }
  //***************************************************برای ارسال پیامک به تعمیرکاران******************************* */
  open_sms_for_repairmans(i: number) {
    this.dialog.open(ReceptionRepairmanSmsComponent, {
      'width': '30rem',
      'height': 'auto',
      data: { reception_id: this.list_record[i].repairman_reception_id, creator: this.creator }
    })
  }
  //***************************************************برای ارسال پیامک تایم لاین******************************* */
  open_sms_for_timeline(i: number) {
    this.dialog.open(ReceptionTimelineSmsComponent, {
      'width': '30rem',
      'height': 'auto',
      data: { reception_id: this.list_record[i].repairman_reception_id, creator: this.creator }
    })
  }
  //********************************************************************************************************** */
  openchart() {
    this.dialog.open(ChartsComponent, {
      width: '95%',
      height: '80vh',
      data: { creator: this.creator, title: " پذیرش ", address1: 6811, address2: 7075, display_chart1: true, display_chart2: true, has_price: false }
    });
  }
  //*******************************************************************دو تایع زیر وب سرویس های پوششی برای کنترل خالی و پر بودن قفسه هستند************************************************************ */
  get_reception_with_full_shelf() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6620, creator: this.creator }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.empty_shelf_and_reception(res['result'][i].repairman_reception_id, res['result'][i].repairman_reception_shelf);
          }
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  empty_shelf_and_reception(id: number, shelf: number) {
    var obj = { address: 6621, shelf: shelf, creator: this.creator, id: id }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  openColumnConfigDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '25rem';
    dialogConfig.height = "auto";
    dialogConfig.data = { columns: this.columns, title: this.title_of_order, sender: 1 };
    const dialogRef = this.dialog.open(ColumnConfigDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.load_table_Config();
      }
    });
  }
  setcolConfig() {
    this.columns[0].hideable = false;
    this.columns[1].hideable = false;
    this.columns[18].hideable = false;
  }

  load_table_Config() {
    const savedColumnConfig = localStorage.getItem(this.title_of_order);
    if (savedColumnConfig) {
      const savedColumns = JSON.parse(savedColumnConfig);
      this.columns = savedColumns.map((col: { name: string; isHiden: boolean | undefined; sortable: boolean | undefined; hideable: boolean | undefined; disable: boolean | undefined }) => new TableColumn(col.name, col.isHiden, col.sortable, col.hideable));
      this.displayedColumns = this.columns.filter(cd => !cd.isHiden).map(cd => cd.name);
    }
  }
  resetHeaders() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '28rem',
      height: '9rem',
      data: { message: 'آیا شما می خواهید تنظیمات نمایش ستون ها به حالت پیش فرض برگردد؟' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const savedColumnConfig = localStorage.getItem(this.title_of_order);
        if (savedColumnConfig) {
          localStorage.removeItem(this.title_of_order);
        }
        const OrginalColumnConfig = localStorage.getItem(this.orginal_order);
        if (OrginalColumnConfig) {
          this.displayedColumns = JSON.parse(OrginalColumnConfig);
          this.columns = this.displayedColumns.map(column => new TableColumn(column, false, true, true));
          this.setcolConfig();
        }
        // Proceed with the action
      } else {
        this.matSnackBar.open("بازگردانی تنظیمات ستونها به پیش فرض توسط کاربر ملغی گردید", "بستن", { duration: 5000 });
      }
    });
  }
  //************************************************************************************ */
  change_resize() {
    //this.serverService.change_window_resize(1,'',0);
  }//end change_resize
  //*******************************************************************************
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) {
      this.loading = false;
      this.loading2 = false;
    }
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 4000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}
